export class Podcasts {
  public carouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Content creation',
      categories: [],
      active: true
    }, {
      title: 'Advertising',
      categories: []
    }
  ];
}